import { defaultGrid, defaultRow } from "../../components/helpers/grid";
import BaseReducer from "./BaseReducer";

class SessionalPositionsReducer extends BaseReducer {
  domain = "Sessional";
  type = "Positions";

  initialState = {
    loaded: false,
    grid: defaultGrid,
    activeRow: defaultRow,
    offline: 0,
    nonOp: 0,
    online: 0,
    doorOpen: 0,
    inPlay: 0,
    showOnline: true,
    showOffline: true,
    showNonOp: true,
    showDoorOpen: true,
    showInPlay: true,
  };
}

const reducer = new SessionalPositionsReducer();

export default reducer;
